module.exports = __webpack_public_path__ + "assets/google-slide-active.e5264ca5.svg";